import React from "react";
import { MapIcon } from "@heroicons/react/solid";
import { FaMapMarkerAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import useTripDrivers from "../../hooks/trips/useTripDrivers";
import Pagination from "../../components/pagination";
import Spinner from "../../components/loader/Spinner";
import NoDataFound from "../../components/ui/NoDataFound";
import RoundedContainer from "../../components/containers/RoundedContainer";
import SearchBar from "../../components/inputs/SearchBar";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeaderCell,
	TableRow,
} from "../../components/table/Table";

const Users = () => {
	const {
		driversData,
		isLoading,
		pageNo,
		searchQuery,
		handlePageClick,
		handleSearchChange,
	} = useTripDrivers();

	const drivers = driversData?.data?.data || [];
	const totalCount = driversData?.data?.total_count || 0;
	const perPage = driversData?.data?.per_page || 10;

	return (
		<div className="px-5 py-4">
			<div className="mb-4 flex items-center justify-between">
				<h1 className="text-xl font-semibold">Trips</h1>
			</div>

			<RoundedContainer className="mb-4">
				<div className="w-[400px]">
					<SearchBar
						value={searchQuery}
						placeholder="Search By Name..."
						onChange={handleSearchChange}
					/>
				</div>
			</RoundedContainer>

			{isLoading ? (
				<div className="flex justify-center items-center py-20">
					<Spinner />
				</div>
			) : (
				<>
					<RoundedContainer>
						{drivers.length <= 0 ? (
							<div className="py-8">
								<NoDataFound message={"No Drivers Found"} />
							</div>
						) : (
							<div className="max-w-full overflow-x-auto">
								<Table className="table-auto w-full">
									<TableHead>
										<TableHeaderCell className="w-[10%] text-center">
											Sr.No
										</TableHeaderCell>
										<TableHeaderCell className="w-[30%]">
											Name
										</TableHeaderCell>
										<TableHeaderCell className="w-[25%]">
											Number
										</TableHeaderCell>
										<TableHeaderCell className="w-[17%] text-center">
											Live Location
										</TableHeaderCell>
										<TableHeaderCell className="w-[18%] text-center">
											Total Trips
										</TableHeaderCell>
									</TableHead>
									<TableBody>
										{drivers.map((driver, index) => (
											<TableRow key={driver.company_employee_id || index}>
												<TableCell className="text-center text-dark font-medium text-sm">
													{pageNo * perPage + index + 1}
												</TableCell>
												<TableCell className="text-dark font-medium text-sm">
													{driver.employee_name}
												</TableCell>
												<TableCell className="text-dark font-medium text-sm">
													{driver.phone || "----"}
												</TableCell>
												<TableCell className="text-dark font-medium text-sm">
													<a
														target="_blank"
														rel="noreferrer noopener"
														href={`https://www.google.com/maps?q=${driver.latitude || 0},${driver.longitude || 0}`}
														className="w-max mx-auto flex justify-center items-center text-center font-medium space-x-2 text-primary hover:text-blue-700 px-3 py-1.5 rounded-md hover:bg-gray-100 transition-colors duration-200"
													>
														<FaMapMarkerAlt className="w-4 h-4" />
														<span className="text-sm">View</span>
													</a>
												</TableCell>
												<TableCell className="text-dark font-medium text-sm">
													<Link
														to={`trips?driver_id=${driver.company_employee_id}`}
														className="w-max mx-auto flex justify-center items-center text-center font-medium space-x-2 text-primary hover:text-blue-700 px-3 py-1.5 rounded-md hover:bg-gray-100 transition-colors duration-200"
													>
														<MapIcon className="w-5 h-5" />
														<span className="text-sm">View</span>
													</Link>
												</TableCell>
											</TableRow>
										))}
									</TableBody>
								</Table>
							</div>
						)}
					</RoundedContainer>

					{totalCount > perPage && (
						<RoundedContainer className="mt-4">
							<Pagination
								lengthofItems={totalCount}
								onPageChange={handlePageClick}
								limit={perPage}
								currentPage={pageNo}
							/>
						</RoundedContainer>
					)}
				</>
			)}
		</div>
	);
};

export default Users;
